import { render, staticRenderFns } from "./speakers.vue?vue&type=template&id=5ded0ad0&scoped=true&"
import script from "./speakers.vue?vue&type=script&lang=js&"
export * from "./speakers.vue?vue&type=script&lang=js&"
import style0 from "./speakers.vue?vue&type=style&index=0&id=5ded0ad0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ded0ad0",
  null
  
)

export default component.exports